import { render, staticRenderFns } from "./role-autocomplete.vue?vue&type=template&id=bc81d4a2&scoped=true&"
import script from "./role-autocomplete.vue?vue&type=script&lang=js&"
export * from "./role-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc81d4a2",
  null
  
)

export default component.exports